import React from "react";

import { logRocketCaptureException } from "src/lib/logrocket-helpers";
import { cacheService } from "src/services";

export default function WithClientConfigBoundary(
  WrappedComponent: React.JSXElementConstructor<any>
) {
  return class ClientConfigBoundary extends React.PureComponent {
    componentDidCatch(error: Error, info: React.ErrorInfo) {
      logRocketCaptureException(error, { componentStack: info.componentStack });
      cacheService.clear();
      window.location.reload();
    }

    render() {
      if (!WrappedComponent) return null;
      return <WrappedComponent {...this.props} />;
    }
  };
}
